import { getUserId } from "./localInfo";
import { post } from "./labit-connection";

export let updateLastConnection = async () => {
  const id = getUserId();
  const now = moment().format("YYYY-MM-DD HH:mm:ss");
  await post(
    `update people
        set lastActivity='${now}'
        where contact_id=${id}`
  );
};
